import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'aos/dist/aos.css';
import '../css/About.css'
import '../css/Common-style.css'
import '../css/Animation.css'
import About_image from '../images/About_image.jpg'
import pdf from "../css/Resume_U.pdf"

const About = ()=>{
    return(
        <>
        <section className="about" id="About">
            <h1 data-aos="fade-left" className="title text-center">ABOUT ME</h1>

            <div className="container about-container">
                <div data-aos-delay='1000' className="row about-row">
                    <div data-aos="flip-right" data-aos-duration="2000" className="col-md-4 offset-md-1 image">
                        <img src={About_image} className="about-img" alt="Giridhar Holla working"/>
                    </div>

                    <div data-aos="flip-right" data-aos-duration="2000" className="col-md-6 offset-md--2 description">
                        <p className="about-des first-para">
                            A Web Development enthusiast who is capable of using his technical skills for the betterment of the organization. 
                           Fine practical knowledge and working experience with C, Python, JavaScript HTML5, CSS3, ReactJS, Nodejs, Mysql and Mongodb.
                        </p>

                        <br/>

                        <p className="about-des second-para">
                            A Hard-working web developer with a flair for creating elegant solutions in the least amount of time. 
                        </p>

                        <div className="about-info">
                            <div>
                                <span className="about-info-title">Fresher</span>
                                <span className="about-info-name">Years<br/>Experience</span>
                            </div>
                            <div>
                                <span className="about-info-title">04+</span>
                                <span className="about-info-name">Completed <br/>Projects</span>
                            </div>
                            <div>
                                <span className="about-info-title">01</span>
                                <span className="about-info-name">Internship <br/>Done</span>
                            </div>
                        </div>

                        <div className="download-cv">
                        <a href={pdf} className="btn btn-primary" download="N Giridhara Holla - Resume">
                            DOWNLOAD CV<i className="fas fa-download button-icon"></i>
                        </a>
                    </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    );
}

export default About;